import { Badge } from '@kiwicom/orbit-components';
import { FormattedMessage } from 'react-intl';

type Props = {
  readonly isAdded: boolean;
  readonly dataTest?: string;
};

const IsAddedBadge = (props: Props): JSX.Element | null => {
  if (!props.isAdded) {
    return null;
  }

  return (
    <Badge dataTest={props.dataTest} type="success">
      <FormattedMessage id="account_v2.components.is_added_badge.is_added" defaultMessage="Added" />
    </Badge>
  );
};

export default IsAddedBadge;
